const guatemala = [
    { "code": "Alta Verapaz", "name": "Alta Verapaz" },
    { "code": "Baja Verapaz", "name": "Baja Verapaz" },
    { "code": "Chimaltenango", "name": "Chimaltenango" },
    { "code": "Chiquimula", "name": "Chiquimula" },
    { "code": "El Progreso", "name": "El Progreso" },
    { "code": "Escuintla", "name": "Escuintla" },
    { "code": "Guatemala", "name": "Guatemala" },
    { "code": "Huehuetenango", "name": "Huehuetenango" },
    { "code": "Izabal", "name": "Izabal" },
    { "code": "Jalapa", "name": "Jalapa" },
    { "code": "Jutiapa", "name": "Jutiapa" },
    { "code": "Petén", "name": "Petén" },
    { "code": "Quetzaltenango", "name": "Quetzaltenango" },
    { "code": "Quiché", "name": "Quiché" },
    { "code": "Retalhuleu", "name": "Retalhuleu" },
    { "code": "Sacatepéquez", "name": "Sacatepéquez" },
    { "code": "San Marcos", "name": "San Marcos" },
    { "code": "Santa Rosa", "name": "Santa Rosa" },
    { "code": "Sololá", "name": "Sololá" },
    { "code": "Suchitepéquez", "name": "Suchitepéquez" },
    { "code": "Totonicapán", "name": "Totonicapán" },
    { "code": "Zacapa", "name": "Zacapa" }
  ]
export default guatemala;